import { usersAPI } from '../lib/api';
import { getCurrentCompanyId } from '../utils/auth';

// Mock data fallback for when API calls fail
const mockUsers = [
  {
    id: 1,
    email: 'admin@accountingpro.com',
    firstName: 'Admin',
    lastName: 'User',
    role: 'admin',
    companyId: 1,
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 2,
    email: 'user@accountingpro.com',
    firstName: 'Regular',
    lastName: 'User',
    role: 'user',
    companyId: 1,
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z'
  },
  {
    id: 3,
    email: 'accountant@accountingpro.com',
    firstName: 'Staff',
    lastName: 'Accountant',
    role: 'accountant',
    companyId: 1,
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z'
  }
];

export const getUsers = async (companyId = null) => {
  try {
    const actualCompanyId = companyId || getCurrentCompanyId();
    if (!actualCompanyId) {
      console.warn('No company ID available, using mock data');
      return mockUsers;
    }
    
    const response = await usersAPI.getAll(actualCompanyId);
    return response.data || [];
  } catch (error) {
    console.error('Error in getUsers, using mock data:', error);
    return mockUsers;
  }
};

export const createUser = async (userData) => {
  try {
    const response = await usersAPI.create(userData);
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const updateUser = async (id, userData) => {
  try {
    const response = await usersAPI.update(id, userData);
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const deleteUser = async (id) => {
  try {
    await usersAPI.delete(id);
    return true;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

export const updateUserStatus = async (id, isActive) => {
  try {
    const response = await usersAPI.update(id, { isActive });
    return response.data;
  } catch (error) {
    console.error('Error updating user status:', error);
    throw error;
  }
};